module.exports = __webpack_public_path__ + "assets/img/forum.af784f6.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/icons/forum.png
// module id = IIXg
// module chunks = 50